import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-030c138a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = { class: "slot-item-description" }

import {SlotItem} from "@/types/Calendar";
import { NSpace, NText, NDivider } from "naive-ui"
import cheerio from "cheerio"


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarSlot',
  props: {
    slotItems: null
  },
  setup(__props: any) {

const props = __props as {
  slotItems: SlotItem[],
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NSpace), {
    class: "slot-items",
    size: "small",
    vertical: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slotItems.slice(0,2), (slotItem, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: slotItem }, [
          (index > 0)
            ? (_openBlock(), _createBlock(_unref(NDivider), {
                key: 0,
                class: "slot-divider"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_unref(NText), {
              class: _normalizeClass(["type", { appointment : slotItem.type.toLowerCase() === 'appointment' }]),
              depth: "3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotItem.start.toTimeString().slice(0, 5)) + " - " + _toDisplayString(slotItem.end.toTimeString().slice(0, 5)), 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(cheerio).load(slotItem.description)("body").prop("innerText")), 1)
          ])
        ], 64))
      }), 128)),
      (__props.slotItems.length > 2)
        ? (_openBlock(), _createBlock(_unref(NSpace), {
            key: 0,
            justify: "end",
            class: "slot-end-space"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" +" + _toDisplayString(__props.slotItems.length - 2), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})